
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".67","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M4 13.5h3M4 8.5h3M4 18.5h3M4 23.5h3M27 27V5a1 1 0 00-1-1H8a1 1 0 00-1 1v22a1 1 0 001 1h18a1 1 0 001-1z","stroke":"#fff","stroke-width":"2"}}),_c('path',{attrs:{"d":"M10.574 10.99l1.5 1 2-2.5M10.574 20.5l1.5 1 2-2.5M17 11h6.5M17.074 21h6.5","stroke":"#56BFC7","stroke-width":"1.8"}})])])
          )
        }
      }
    